import axios from "axios";

const instance = axios.create({
  baseURL: 'https://api.takemytickets.co.in/api', // aws api url
  // baseURL: 'http://localhost:5000/api',
});

export default instance;
